export default __webpack_public_path__ + "97dffbfe9565280b8f3848b18d0172b9.png";